<template>
  <div class="quality-inspection-pc">
    <div class="machine-type">
      <div class="panel" @click="intoSwanProduct">天鹅</div>
    </div>
    <product-info feedbackType="日常生产"></product-info>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter, useRoute } from "vue-router";
import feedbackVue from "../components/feedback/index.vue";
import responsibilityVue from "../components/responsibility.vue";
import productInfo from "@/views/productDaily/pc/info/index.vue";

export default defineComponent({
  components: { responsibilityVue, feedbackVue, productInfo },
  setup() {
    const router = useRouter();

    const route = useRoute();

    const intoSwanProduct = () => {
      router.push({
        path: "/swanproduce",
        query: {
          meta: encodeURI(JSON.stringify(route.meta)),
        },
      });
    };

    return {
      intoSwanProduct,
    };
  },
});
</script>

<style lang="less" scoped>
.quality-inspection-pc {
  width: 100%;
  background: #fff;
  height: calc(100vh - 120px);
  background: #fff;
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 10px;
  position: relative;
  .machine-type {
    cursor: pointer;
    position: absolute;
    background: #fff;
    right: 10px;
    top: 10px;
    z-index: 9;
    .panel {
      width: 100px;
      height: 100px;
      font-size: 30px;
      text-align: center;
      line-height: 100px;
      box-shadow: 0 0 10px 0 #ccc;
      border-radius: 20px;
    }
  }
}
</style>
